import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";

function NoticeList() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get("/Master/GetNotice");

      setServices(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to load services",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card shadow">
      <div className="card-header bg-primary text-white">
        <h4 className="mb-0">Notice List</h4>
      </div>

      <div className="card-body">
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered table-striped">
              <thead className="table-dark">
                <tr>
                  <th>ID</th>
                  <th>Heading</th>
                  <th>Description</th>
                  <th>Images</th>
                  <th>Is Home</th>
                  <th>Created Date</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {services.length > 0 ? (
                  services.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      <td>
                          <a
                            href={`https://localhost:7038/${item.upload1}`}
                            className="me-2"
                          >{item.upload1_Name}</a>
                         <a
                            href={`https://localhost:7038/${item.upload2}`}
                            className="me-2"
                          >{item.upload2_Name}</a>
                           <a
                            href={`https://localhost:7038/${item.upload4}`}
                            className="me-2"
                          >{item.upload3_Name}</a>
                           <a
                            href={`https://localhost:7038/${item.upload4}`}
                            className="me-2"
                          >{item.upload4_Name}</a>
                      </td>
                      {/* const imageBaseUrl = "https://services.mcambala.gov.in";

<img src={`${imageBaseUrl}/${item.newsImgS}`} alt="Small" width="60" />
<img src={`${imageBaseUrl}/${item.newsImgB}`} alt="Big" width="60" /> */}
                      <td>
                        {item.isHome === 1 ? (
                          <span className="badge text-success">
                            <i className="bi bi-eye-fill"></i> Yes
                          </span>
                        ) : (
                          <span className="badge text-danger">
                            <i className="bi bi-eye-slash-fill"></i> No
                          </span>
                        )}
                      </td>
                      <td>{item.created_Date}</td>

                      <td>
                        {/* {item.isActive
                            ? "Active"
                            : "Inactive"} */}

                        {item.status_Info === 1 ? (
                          <span className="badge bg-success">
                            <i className="bi bi-eye-fill"></i> Active
                          </span>
                        ) : (
                          <span className="badge bg-danger">
                            <i className="bi bi-eye-slash-fill"></i> Inactive
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No Record Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default NoticeList;
